// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'history-solid';

export const Component = () => (
  <path d='M20.93 20.93c-4.788 4.789-12.55 4.789-17.339 0-4.788-4.788-4.788-12.55 0-17.339 4.788-4.788 12.551-4.788 17.34 0 4.788 4.788 4.788 12.551 0 17.34Zm-9.32-8.477s0 .38.283.616l2.568 2.155a.503.503 0 1 0 .647-.77l-2.492-2.09v-4.7a.503.503 0 0 0-1.006 0v4.788ZM5.154 14.24a7.417 7.417 0 0 1-.12-3.455 7.353 7.353 0 0 1 2.011-3.74 7.375 7.375 0 1 1 10.43 10.43 7.342 7.342 0 0 1-4.343 2.11c-.275.11-.445.28-.51.509-.097.343.34.57.558.557 1.985-.111 3.49-.948 5.007-2.464a8.382 8.382 0 1 0-14.174-7.422 8.44 8.44 0 0 0 .052 3.256l-1.371-1.372a.503.503 0 0 0-.711.711l2.37 2.37a.501.501 0 0 0 .373.147.5.5 0 0 0 .375-.15l2.351-2.39a.502.502 0 1 0-.717-.705l-1.58 1.607v.001Z' />
);

export const viewBox = '0 0 25 25';
